import { getHexLocationDisplay } from '@event-black/shared/lib/h3.js';
import { resolveHexToLocationName } from '@event-black/shared/data/entity-hex-map.js';
import styles from './HexLocationLink.module.css';

interface HexLocationLinkProps {
  readonly hexId: string;
}

const HexLocationLink = ({ hexId }: HexLocationLinkProps): React.ReactElement => {
  const display = getHexLocationDisplay(hexId, resolveHexToLocationName);

  return (
    <a
      href={display.mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
      title={`View ${hexId} on Google Maps`}
    >
      {display.displayLabel} ({display.lat.toFixed(4)}, {display.lng.toFixed(4)}) ↗
    </a>
  );
};

export { HexLocationLink };
